<template>
  <div class="mobileViewStyle calendar-log">
    <!-- 写工作日志（企业微信手机端）：日志按人按天记，每日一条 -->
    <div class="detail-body">
      <list-card :label="'工作日志 · ' + dateLabel" type="form">
        <el-input class="log-textarea" v-model="logResult" type="textarea" :rows="6"
                  placeholder="今天做了什么、进展如何"/>
      </list-card>

      <!-- 当日目标：只是给人参照，点「拼装日志」按它们的进度生成一份 -->
      <list-card v-if="goals.length" label="当日目标" type="form">
        <data-column v-for="item in goals" :key="item.id" :label="item.title">
          <span class="goal-state">{{ goalState(item) }}</span>
        </data-column>
      </list-card>
    </div>

    <div class="detail-footer">
      <mobile-button @click="cancel">取消</mobile-button>
      <mobile-button @click="assembleLog">拼装日志</mobile-button>
      <mobile-button el-type="primary" @click="saveLog">保存</mobile-button>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import MobileButton from "@/components/qywx/button/MobileButton.vue";
import calendarApi from "@/api/dz-crm/kpi/calendarApi";
import {TYPE_LOG, statusName} from "@/views/h5/crm/kpi/kpiCalendarDictionary";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "KCL",
  components: {
    MobileButton, DataColumn, ListCard
  },
  data() {
    return {
      employeeId: "",
      goalDate: "",
      logResult: "",
      rows: [],
      pageTitle: "",
    };
  },
  computed: {
    dateLabel() {
      return this.goalDate ? this.goalDate.slice(5) : "";
    },
    /** 当天的目标（日志行本身不算目标） */
    goals() {
      return (this.rows || []).filter(row => Number(row.calendarType) !== TYPE_LOG);
    }
  },
  created() {
    this.pageTitle = document.title;
    document.title = "写工作日志";
    this.employeeId = this.route.query.employeeId || "";
    this.goalDate = this.route.query.date || "";
    if (!this.employeeId || !this.goalDate) {
      this.$message.error("缺少员工或日期参数");
      this.router.back();
      return;
    }
    // queryDay 返回的是当天日历行数组：日志行（calendarType=1）也在这个数组里，
    // 从它里面挑出当天日志的文本即可（按 {result, calendarList} 取是取不到的）
    calendarApi.queryDay(this.employeeId, this.goalDate).then(list => {
      const rows = list || [];
      const logRow = rows.find(item => Number(item.calendarType) === TYPE_LOG);
      this.logResult = (logRow && logRow.result) || "";
      this.rows = rows;
    });
  },
  unmounted() {
    document.title = this.pageTitle;
  },
  methods: {
    goalState(item) {
      const marks = [];
      if (Number(item.kpiStatus) === 100) {
        marks.push("已完成");
      } else if (item.kpiStatus !== null && item.kpiStatus !== undefined) {
        marks.push(statusName(item.kpiStatus));
      }
      if (Number(item.hours) > 0) {
        marks.push("消耗工时 " + item.hours + "h");
      }
      return marks.length ? marks.join("、") : "—";
    },
    /**
     * 拼装日志：把当天「已完成」或「消耗工时 > 0」的目标拼成文本
     *
     * 覆盖而不是追加 —— 这个按钮的语义是「照当前进度生成一份」，追加会让用户
     * 连点两次就得到重复内容。用户想补充可以自己再编辑文本框。
     */
    assembleLog() {
      const lines = this.goals
          .filter(row => Number(row.kpiStatus) === 100 || Number(row.hours) > 0)
          .map(row => {
            const marks = [];
            if (Number(row.kpiStatus) === 100) {
              marks.push("已完成");
            }
            if (Number(row.hours) > 0) {
              marks.push("消耗工时 " + row.hours + "h");
            }
            return marks.length ? row.title + "：" + marks.join("、") : row.title;
          });
      if (!lines.length) {
        this.$message.warning("当天没有可拼装的目标");
        return;
      }
      this.logResult = lines.join("\n");
    },
    cancel() {
      this.router.back();
    },
    saveLog() {
      if (!this.logResult) {
        this.$message.error("请填写日志内容");
        return;
      }
      // 只写日志：calendarIds / calendarList 传空，同步任何目标行
      calendarApi.markDone({
        employeeId: this.employeeId,
        goalDate: this.goalDate,
        result: this.logResult,
        calendarIds: [],
        calendarList: [],
      }).then(() => this.router.back());
    }
  }
};
</script>

<style lang="scss" scoped>
.calendar-log{
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--yq-background-color);
  .detail-body{
    flex: 1;
    overflow-y: auto;
    padding: 10px;
  }
  .detail-footer{
    flex: none;
    display: flex;
    gap: 10px;
    padding: 10px;
    background: #FFF;
    box-shadow: 0 -1px 4px var(--yq-shadow);
    :deep(.mobile-button){
      flex: 1;
    }
  }
  // 日志是要写一段话的，用整块 textarea，去掉自带边框
  :deep(.log-textarea){
    .el-textarea__inner{
      box-shadow: none;
      background: var(--yq-background-color);
      border-radius: 6px;
      padding: 10px;
      font-size: var(--yq-font-size-mini-mobile);
      line-height: 1.6;
    }
  }
  .goal-state{
    color: var(--yq-font-color-desc);
  }
}
</style>
